"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var _vue = _interopRequireDefault(require("vue"));
var _state = _interopRequireDefault(require("@/libs/state"));
var ipRegex = _interopRequireWildcard(require("ip-regex"));
var IrcdDiffs = _interopRequireWildcard(require("@/helpers/IrcdDiffs"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _common = require("./common");
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** @module */

var nextId = 0;
var UserState = /*#__PURE__*/function () {
  function UserState(networkid, user, state) {
    (0, _classCallCheck2.default)(this, UserState);
    this.id = ++nextId;
    this.networkid = networkid;
    this.key = user.nick.toUpperCase();
    this.nick = user.nick;
    this.host = user.host || '';
    this.username = user.username || '';
    this.realname = user.realname || '';
    this.modes = user.modes || [];
    this.away = user.away || '';
    this.colour = user.colour || '';
    this.account = user.account || '';
    this.buffers = Object.create(null);
    this.hasWhois = false;
    this.hasWhoFlags = false;
    this.typingState = Object.create(null);
    this.ignore1 = user.ignore || false;
    this.hasSimplex = !!user.hasSimplex;
    this.simplexRequestId = user.simplexRequestId || '';
    this.avatarCache = null;
    _vue.default.observable(this);
    (0, _common.def)(this, 'state', state, false);
    Object.defineProperty(this, 'ignore', {
      configurable: true,
      enumerable: true,
      get: function get() {
        // Return the private backing field's value
        return this.ignore1;
      },
      set: function set(newValue) {
        var booleanValue = !!newValue;
        // Only proceed and emit if the value is actually changing
        if (this.ignore1 !== booleanValue) {
          // Update the private backing field (Vue tracks this change)
          this.ignore1 = booleanValue;

          // Emit the global event
          (0, _state.default)().$emit('user.ignore.changed', {
            user: this,
            ignored: booleanValue
          });
        }
      }
    });

    // Whois details are non-enumerable properties (vues $watch won't cover these properties)
    // watch hasWhois to know when this data is populated
    (0, _common.def)(this, 'whois', {
      actual_ip: '',
      actual_username: '',
      actual_hostname: '',
      helpop: '',
      bot: '',
      server: '',
      server_info: '',
      operator: '',
      channels: '',
      modes: '',
      idle: '',
      logon: '',
      registered_nick: '',
      secure: '',
      special: ''
    }, true);

    // Who flags are non-enumerable properties (vues $watch won't cover these properties)
    // watch hasWhoFlags to know when this data is populated
    (0, _common.def)(this, 'whoFlags', {
      bot: null,
      operator: null,
      registered: null,
      secure: null
    }, true);
  }
  (0, _createClass2.default)(UserState, [{
    key: "avatar",
    get: function get() {
      if (!this.avatarCache) {
        this.avatar = {
          small: '',
          large: ''
        };
        (0, _state.default)().$emit('user.avatar.create', {
          user: this
        });
      }
      return this.avatarCache;
    },
    set: function set(value) {
      this.avatarCache = value;
    }
  }, {
    key: "getColour",
    value: function getColour() {
      if (!this.colour) {
        this.colour = TextFormatting.createNickColour(this.nick);
      }
      // default will use the themes default text colour
      return this.colour === 'default' ? '' : this.colour;
    }
  }, {
    key: "getNetwork",
    value: function getNetwork() {
      return this.state.getNetwork(this.networkid);
    }
  }, {
    key: "isAway",
    value: function isAway() {
      return this.away && this.away !== 'offline';
    }
  }, {
    key: "isOffline",
    value: function isOffline() {
      return this.away === 'offline';
    }
  }, {
    key: "createBanMask",
    value: function createBanMask() {
      // try to ban via user account first
      if (this.account) {
        // if EXTBAN is supported use that
        var extban = IrcdDiffs.extbanAccount(this.getNetwork());
        if (extban) {
          return extban + ':' + this.account;
        }

        // if the account name is in the host ban the host
        // Eg. user@network/user/accountname
        if (this.host.toLowerCase().indexOf(this.account.toLowerCase()) > -1) {
          return '*!*@' + this.host;
        }
      }

      // if an ip address is in the host and not the whole host ban the ip
      // Eg. user@gateway/1.2.3.4
      var ipTest = new RegExp('(' + ipRegex.v4().source + '|' + ipRegex.v6().source + ')');
      if (ipTest.test(this.host)) {
        var match = this.host.match(ipTest)[0];
        if (match !== this.host) {
          return '*!*@*' + match + '*';
        }
      }

      // if an 8 char hex is the username ban by username. Commonly used in gateways
      // Eg. 59d4c432@a.clients.kiwiirc.com
      var hexTest = /^([a-f0-9]{8})$/i;
      if (hexTest.test(this.username)) {
        var _match = this.username.match(hexTest)[0];
        return '*!' + _match + '@*';
      }

      // fallback to default_ban_mask from config
      var mask = this.state.setting('buffers.default_ban_mask');
      mask = mask.replace('%n', this.nick);
      mask = mask.replace('%i', this.username);
      mask = mask.replace('%h', this.host);
      return mask;
    }
  }, {
    key: "typingStatus",
    value: function typingStatus(_target, status) {
      var _this = this;
      var target = _target.toUpperCase();
      if (!status) {
        return this.typingState[target] || {
          status: ''
        };
      }
      var typing = this.typingState[target];
      if (!typing) {
        _vue.default.set(this.typingState, target, {
          started: 0,
          status: ''
        });
        typing = this.typingState[target];
      }
      if (typing.timeout) {
        clearTimeout(typing.timeout);
        typing.timeout = null;
      }
      if (status === 'done') {
        _vue.default.delete(this.typingState, target);
        return null;
      }
      typing.started = Date.now();
      typing.status = status;

      // Paused state gets a longer timeout as it's usually someone stopping typing
      // to think about their words
      var timeoutLen = status === 'paused' ? 30000 : 6000;
      typing.timeout = setTimeout(function () {
        return _this.typingStatus(target, 'done');
      }, timeoutLen);
      return typing;
    }
  }]);
  return UserState;
}();
exports.default = UserState;